import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[OnHoverDarken]'
})
export class OnHoverDarken {

  constructor (
    private el: ElementRef,
  ) {}

  @Input() color: string; // Hex value of color to darken

  // Add background darken on mouse hover
  @HostListener('mouseenter') onMouseEnter() {
    if(this.color.indexOf('rgb') >= 0){
      this.setBackgroundColor(this.shadeColor2(this.rgbToHex(this.color), -0.2));
    } else {
      this.setBackgroundColor(this.shadeColor2(this.color, -0.2));
    }
  }

  // Remove background darken on mouse leave
  @HostListener('mouseleave') onMouseLeave() {
    this.setBackgroundColor(this.color);
  }

  /**
   * Set the background color of the current element
   * @param {string} color - hex value of color with pound symbol -- e.g. #c51813
   */
  setBackgroundColor(color: string) {
    this.el.nativeElement.style.backgroundColor = color;
  }

  /**
   * Shades the given color by a given percent, see linked stack overflow article
   * https://stackoverflow.com/a/13542669
   * @param {string} color - hex value of the color with the pound symbol -- e.g. #c51813
   * @param {number} percent - floating point number between -1.0 and 1.0
   */
  shadeColor2(color: string, percent: number): string {
    // tslint:disable-next-line:one-variable-per-declaration
    const f = parseInt(color.slice(1), 16), t = percent < 0 ? 0 : 255, p = percent < 0 ? percent * -1 : percent, R = f >> 16, G = f >> 8 & 0x00FF, B = f & 0x0000FF;
    return '#' + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
  }

  /**
   * converts the rgb colors to hex
   * 
   * @param { string } - rgb 
   * @return { string } - color as hex
   */
  rgbToHex(rgb: string): string {
    const rgbNum = rgb.split(",").map(e => {
      return parseInt(e.replace(/[rgb()]/g,''));
    });

    // @see https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
    return "#" + ((1 << 24) + (rgbNum[0] << 16) + (rgbNum[1] << 8) + rgbNum[2]).toString(16).slice(1);
  }

}
